// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__Kwfuq","containerItemsCenter":"Skeleton_containerItemsCenter__3YKoe"};